module.exports = __webpack_public_path__ + "static/eth-logo-sm.db1fba70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/eth-logo-sm.png
// module id = 475
// module chunks = 35783957827783